import React from 'react'
import Layout from 'components/common/Layout'
import { LecturesLibrary } from 'components/lecturesPage/LecturesLibrary'
import * as SC from 'styles/lecturesStyles'
import Cover from 'components/common/Cover'
import BackgroundImage from 'components/common/BackgroundImage'
import { lectures } from 'constants/program'
import LecturesSchedule from 'components/lecturesPage/LecturesSchedule'
import useGetCourses from 'hooks/useGetCourses'
import { BreadcrumbJsonLd, NextSeo } from 'next-seo'

const LecturesPage = () => {
  const courses = useGetCourses()

  return (
    <Layout>
      <>
        <NextSeo
          title="Лекторий"
          description="Секреты продвижения, музыкального менеджмента и цифровой дистрибуции от экспертов индустрии."
          openGraph={{
            url: 'https://newopen.su/lectures',
            title: 'Лекторий | NEW / OPEN',
            description: 'Секреты продвижения, музыкального менеджмента и цифровой дистрибуции от экспертов индустрии.',
            images: [
              {
                url: '/images/lecturesPage/cover1.png',
                width: 800,
                height: 600,
                alt: 'lectures page'
              }
            ]
          }}
        />
        <BreadcrumbJsonLd
          itemListElements={[
            {
              position: 1,
              name: 'Главная',
              item: 'https://newopen.su/'
            },
            {
              position: 2,
              name: 'Лекторий',
              item: 'https://newopen.su/lectures'
            }
          ]}
        />
        <Cover
          src="images/lecturesPage/cover1.png"
          srcMobile="images/lecturesPage/cover-mobile1.png"
          pageData={{ type: 'lecturesPage' }}
        />
        <SC.PageDescription>
          Посетители фестиваля{' '}
          <SC.Name>
            NEW <SC.Slash>/</SC.Slash> OPEN
          </SC.Name>{' '}
          смогут прослушать лекции и принять участие в мастер-классах от экспертов музыкальной индустрии: директоров групп, известных промоутеров и организаторов концертов и представителей музыкальных СМИ.
          <br />
          <br />
          Каждый посетитель также сможет попасть на спиддейтинг. Так называется короткая встреча с экспертом в формате «быстрого свидания». Вы сможете обсудить свой проект за три минуты и получите советы по его улучшению.
          <br />
          <br />
          Участие в лектории фестиваля бесплатное по предварительной регистрации. В этом разделе сайта вы можете увидеть лекции и воркшопы прошлых лет.
        </SC.PageDescription>

        <BackgroundImage
          position="center"
          src="images/lecturesPage/image-center.jpg"
          srcMobile="images/lecturesPage/image-center.jpg"
          srcMobileSize={{ width: '606', height: '237'}}
        />

        {/* <LecturesSchedule lectures={lectures} /> */}

        <LecturesLibrary courses={courses.data.items} />
      </>
    </Layout>
  )
}

export default LecturesPage
